import { useIntl } from "react-intl";

import Drawer from "components/v2/Drawer/Drawer";
import DrawerHeader from "components/v2/Drawer/components/DrawerHeader/DrawerHeader";
import QuickPackingList from "pages/shipper/ShipmentDetails/components/QuickPackingList";

interface PackingListDetailsDrawerProps {
  isOpen: boolean;
  handleClose: () => void;
  data: any;
}

function PackingListDetailsDrawer({ isOpen, handleClose, data }: PackingListDetailsDrawerProps) {
  const intl = useIntl();
  const formattedData = data.map((quickRequest: any) => quickRequest.data);

  return (
    <Drawer size="md" isOpen={isOpen} onClose={handleClose}>
      <DrawerHeader
        title={intl.formatMessage({
          id: "general.packingListDetails",
          defaultMessage: "Packing List Details",
        })}
      />
      {formattedData.length > 0 &&
        formattedData.map((quickRequest: any) => (
          <QuickPackingList
            isDrawer
            quickRequestReference={quickRequest?.organization?.quick_request_reference}
            data={quickRequest}
            loadingData={false}
          />
        ))}
    </Drawer>
  );
}
export default PackingListDetailsDrawer;
